import { render, staticRenderFns } from "./assignment_form.vue?vue&type=template&id=4161694d&scoped=true&"
import script from "./assignment_form.vue?vue&type=script&lang=js&"
export * from "./assignment_form.vue?vue&type=script&lang=js&"
import style0 from "./assignment_form.vue?vue&type=style&index=0&id=4161694d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161694d",
  null
  
)

export default component.exports